// removed by extract-text-webpack-plugin
module.exports = {"container":"Header__container__2UCrH"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/Header.scss
// module id = 1724
// module chunks = 4 14